import { DashboardIFrame } from "components/organisms/DashboardIFrame";

const Academy = () => {
  return <DashboardIFrame page="academy" />;
};

export { Academy };
